import React from "react";
import { PageTitle } from "@/components/DashUI";
import { Card } from "@/components/ui/card";
import { useSettings } from "@/context/SettingsContext";
import { Button } from "@/components/ui/button";
import { ExternalLink, BookOpen, ShieldCheck, FileText, Users } from "lucide-react";
import { Link } from "react-router-dom";

export default function Resources() {
  const settings = useSettings();
  const RES = [
    [Users, "Skool Community", "Join discussions, courses, and live updates in the Care Placement Pro Skool community.", () => window.open(settings.skool_membership_url, "_blank")],
    [BookOpen, "Training Curriculum", "Work through the recommended 12-module curriculum in the Training section.", null, "/app/training"],
    [ShieldCheck, "Compliance Notices", "Review healthcare referral compliance and no-medical-advice notices.", null, "/legal"],
    [FileText, "Earnings Disclaimer", "Understand how illustrative examples differ from guaranteed earnings.", null, "/legal#earnings"],
  ];
  return (
    <div>
      <PageTitle title="Resources" subtitle="Community, curriculum, and compliance materials" />
      <div className="grid gap-5 md:grid-cols-2">
        {RES.map(([Icon, title, desc, action, to]) => (
          <Card key={title} className="flex flex-col p-6" data-testid={`resource-${title}`}>
            <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-sky"><Icon className="h-5 w-5 text-clinical" /></div>
            <h3 className="mt-4 font-heading text-base font-semibold text-navy">{title}</h3>
            <p className="mt-2 flex-1 text-sm text-slate-500">{desc}</p>
            {action ? (
              <Button onClick={action} className="mt-4 bg-navy hover:bg-navy/90">Open <ExternalLink className="ml-1.5 h-4 w-4" /></Button>
            ) : (
              <Button asChild className="mt-4 bg-navy hover:bg-navy/90"><Link to={to}>Open</Link></Button>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
}
